/**------------- About us constants -------------**/

/*  Title and Description  */
export const ABOUT_US_TITLE = "Chi siamo.";
export const ABOUT_US_DESCRIPTION =
	"Siamo Michele Vacca e Michele Scalese, fondatori di <strong>MM Eletricar Service</strong>, officina elettrauto a Gravina in Puglia (BA)." +
	" Un progetto nato dalla passione per l'elettronica d'auto e dall'esperienza nel settore. <br></br>" +
	"Ogni giorno ci dedichiamo ad offrire servizi professionali, trasparenti ed affidabili a chi ama la propria auto e cerca un elettrauto di fiducia a Gravina in Puglia (BA).";

/*  Links  */
export const ABOUT_US_BACKGROUND_IMAGE_LINK =
	"/images/logo-gray.avif";
